import i18n from 'modules/core/lib/i18n'

export const translations = () => ({
  header: i18n.t('contract_versions.flows.update.steps.legal_and_extras.header'),
  contract_type: i18n.t(
    'contract_versions.flows.update.steps.legal_and_extras.contract_type.label'
  ),
  end_date: i18n.t('contract_versions.flows.update.steps.legal_and_extras.end_date.label'),
  end_date_none: i18n.t('contract_versions.flows.update.steps.legal_and_extras.end_date.none'),
  trial_period: i18n.t('contract_versions.flows.update.steps.legal_and_extras.trial_period.label'),
  trial_period_end: i18n.t(
    'contract_versions.flows.update.steps.legal_and_extras.trial_period_end.label'
  ),
  working_day_type: i18n.t(
    'contract_versions.flows.update.steps.legal_and_extras.working_day_type.label'
  ),
  education_level: i18n.t(
    'contract_versions.flows.update.steps.legal_and_extras.education_level.label'
  ),
  regime: i18n.t('contract_versions.flows.update.steps.legal_and_extras.regime.label'),
  tariff_group: i18n.t('contract_versions.flows.update.steps.legal_and_extras.tariff_group.label'),
  occupation_code: i18n.t(
    'contract_versions.flows.update.steps.legal_and_extras.occupation_code.label'
  ),
  classification: i18n.t(
    'contract_versions.flows.update.steps.legal_and_extras.classification.label'
  ),
  cno_occupation: i18n.t(
    'contract_versions.flows.update.steps.legal_and_extras.cno_occupation.label'
  ),
  contribution_type: i18n.t(
    'contract_versions.flows.update.steps.legal_and_extras.contribution_type.label'
  ),
  agreement_code: i18n.t(
    'contract_versions.flows.update.steps.legal_and_extras.agreement_code.label'
  ),
  professional_category: i18n.t(
    'contract_versions.flows.update.steps.legal_and_extras.professional_category.label'
  ),
  cotization_group: i18n.t(
    'contract_versions.flows.update.steps.legal_and_extras.cotization_group.label'
  ),
  contract_observations: i18n.t(
    'contract_versions.flows.update.steps.legal_and_extras.contract_observations.label'
  ),
  custom_fields: i18n.t(
    'contract_versions.flows.update.steps.legal_and_extras.custom_fields.label'
  ),
  custom_fields_tooltip: i18n.t(
    'contract_versions.flows.update.steps.legal_and_extras.custom_fields.tooltip'
  ),
  custom_fields_none: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.custom_fields.none'
  ),
  teleworking: i18n.t('contract_versions.flows.update.steps.legal_and_extras.teleworking.label'),
  work_type: i18n.t('contract_versions.flows.update.steps.legal_and_extras.work_type.label'),
  employee_type: i18n.t(
    'contract_versions.flows.update.steps.legal_and_extras.employee_type.label'
  ),
  step: i18n.t('contract_versions.flows.update.steps.legal_and_extras.step.label'),
  level: i18n.t('contract_versions.flows.update.steps.legal_and_extras.level.label'),
  mutual: i18n.t('contract_versions.flows.update.steps.legal_and_extras.mutual.label'),
  forfait_jours: i18n.t(
    'contract_versions.flows.update.steps.legal_and_extras.forfait_jours.label'
  ),
  jours_par_an: i18n.t('contract_versions.flows.update.steps.legal_and_extras.jours_par_an.label'),
  de_employment_type: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_employment_type.label'
  ),
  de_flat_rate_tax: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_flat_rate_tax.label'
  ),
  de_activity_type: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_activity_type.label'
  ),
  de_personal_key_group_id: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.label'
  ),
})
